



























































































































































































































import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import LazyHydrate from 'vue-lazy-hydration'
import LegacySearchService from '~/services/search/LegacySearchService'
import RouteGuardService from '~/services/RouteGuardService'
import {
  computed,
  defineNuxtComponent,
  useStore,
  onMounted,
  onBeforeUnmount,
  onActivated,
  onDeactivated,
  defineVue3AsyncComponent,
  ref,
  watch,
  nextTick
} from '~/utils/nuxt3-migration'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS } from '~/store/modules/shared/user/state'
import { searchFacetsDesktopAd } from '~/constants/ads/search/search'
import { BackendMetaItem, MetaItem } from '~/models/head/types'
import DealerSiteService from '~/services/dealers/site/DealerSiteService'
import { Route } from 'vue-router'
import { ciHistory } from '~/icons/source/regular/history'
import { ciBookmark as ciBookmarkSolid } from '~/icons/source/solid/bookmark'
import { ciBookmark as ciBookmarkRegular } from '~/icons/source/regular/bookmark'
import { ciTrash } from '~/icons/source/regular/trash'
import { ciMyClassifieds } from '~/icons/source/regular/my-classifieds'
import ClassifiedSearchShimmer from '~/components/car/classifieds/search/ClassifiedSearchShimmer.vue'
import ClassifiedSearchResults from '~/components/car/classifieds/search/results/ClassifiedSearchResults.vue'
import CBreadcrumbs from '~/components/shared/configurable/CBreadcrumbs.vue'
import ClassifiedSearchFacetsFloatingButton from '~/components/car/classifieds/search/ClassifiedSearchFacetsFloatingButton.vue'
import { PageState, PAGE_NS } from '~/store/modules/shared/page/state'
import { useUserAgent } from '~/compositions/user-agent'
import { useDeps } from '~/compositions/dependency-container'
import {
  SET_LOADING_RESULTS,
  SET_PARAMS,
  SET_SCROLL_TOP
} from '~/store/modules/shared/classifieds/search/mutation-types'
import PaymentsSummaryWidget from '~/components/car/classifieds/search/results/PaymentsSummaryWidget.vue'
import SellersResultsToggle from '~/components/car/classifieds/search/results/SellersResultsToggle.vue'
import CGoogleAd from '~/components/shared/configurable/ad/CGoogleAd.vue'
import ClassifiedSearchSaveSearchModal from '~/components/car/classifieds/search/ClassifiedSearchSaveSearchModal.vue'
import { defineComponentTranslations } from '~/utils/i18n'
import { ONE_DAY } from '~/constants/duration'
import ClassifiedSearchCategoryPicker from '~/components/car/classifieds/search/facets/ClassifiedSearchCategoryPicker.vue'
import ClassifiedSearchMySearchLinks from '~/components/car/classifieds/search/ClassifiedSearchMySearchLinks.vue'
import { Facet } from '~/models/search/types'
import ClassifiedSearchFacetsComponentsService from '~/services/search/ClassifiedSearchFacetsComponentsService'
import { ciTimes } from '~/icons/source/regular/times'
import { formatNumber } from '~/utils/number'
import { capitalizeSentences } from '~/utils/string'
import { useI18n } from '~/compositions/i18n'

export default defineNuxtComponent({
  name: 'BaseSearchPage',
  components: {
    ClassifiedSearchMySearchLinks,
    ClassifiedSearchCategoryPicker,
    ClassifiedSearchSaveSearchModal,
    CGoogleAd,
    SellersResultsToggle,
    PaymentsSummaryWidget,
    LazyHydrate,
    ClassifiedSearchFacetsFloatingButton,
    CBreadcrumbs,
    ClassifiedSearchResults,
    ClassifiedSearchShimmer,
    ConsentPrompt: defineVue3AsyncComponent(() =>
      import('~/components/shared/consent/ConsentPrompt.vue')
    ),
    PromoModalsWrapper: defineVue3AsyncComponent(() =>
      import('~/components/shared/classified/search/PromoModalsWrapper.vue')
    ),
    PromoBannerPromotion: defineVue3AsyncComponent(() =>
      import('~/components/car/promo-banners/PromoBannerPromotion.vue')
    )
  },
  middleware({ $dep, route, redirect }) {
    const routeIsMyClassifieds = route.name?.startsWith(
      '__classifieds_search_my_classifieds'
    )
    const userIsLoggedIn = $dep(RouteGuardService).userIsLoggedIn()

    if (routeIsMyClassifieds && !userIsLoggedIn) {
      redirect(`/login?gotonext=${route.path}`)
    }
  },
  data() {
    return {
      isPromoModalsWrapperVisible: false,
      isCreditsPromoModalVisible: false
    }
  },
  async asyncData({ route, $error, $dep }) {
    const legacySearchService = $dep(LegacySearchService)

    await legacySearchService.createSearch({
      route,
      errorFn: $error,
      mapSearch: false
    })
  },
  setup() {
    const {
      state: classifiedSearchState,
      dispatch: classifiedSearchDispatch,
      commit: classifiedSearchCommit,
      getters: classifiedSearchGetters
    } = useNamespacedStore<SearchState>(CLASSIFIED_SEARCH_NS)
    const { getters: pageGetters } = useNamespacedStore<PageState>(PAGE_NS)
    const { getters: userGetters } = useNamespacedStore(USER_NS)
    const { isMobile, isPc } = useUserAgent()
    const [
      legacySearchService,
      classifiedSearchFacetsComponentsService
    ] = useDeps(LegacySearchService, ClassifiedSearchFacetsComponentsService)
    const store = useStore()
    const { tc } = useI18n()

    const isSaveSearchModalShown = ref(false)
    const saveSearchLoading = ref(false)

    const unsubscribeFromUserLoad = store.subscribeAction({
      after: action => {
        if (process.server) {
          return
        }

        if (action.type === `${USER_NS}/loadUserSubscribable`) {
          window.location.reload()
        }
      }
    })

    onBeforeUnmount(() => {
      unsubscribeFromUserLoad()

      closeMobileFacetsIfOpen()
      window.removeEventListener('popstate', onPopState)
    })

    onMounted(() => {
      classifiedSearchDispatch('recordListViewsStats', { debounced: false })

      window.history.replaceState(
        { isInSearchPage: true },
        '',
        window.location.href
      )

      window.addEventListener('popstate', onPopState, false)
    })

    onActivated(async () => {
      window.addEventListener('popstate', onPopState, false)

      await nextTick()
      if (scrollTop.value) {
        window.scrollTo(0, scrollTop.value)
        classifiedSearchCommit(SET_SCROLL_TOP, 0)
      }
    })

    onDeactivated(() => {
      closeMobileFacetsIfOpen()
      window.removeEventListener('popstate', onPopState)
    })

    const shouldDisplayAds = computed(() =>
      classifiedSearchGetters('shouldDisplayAds')
    )

    const adsKeyValues = computed(() =>
      classifiedSearchGetters('getAdsKeyValues')
    )

    const selectedFacetsCount = computed(() =>
      classifiedSearchGetters('getFacetsCount')
    )

    const showCategoryPicker = computed(() =>
      classifiedSearchGetters('showCategoryPicker')
    )

    const categoryFacet = computed(() =>
      classifiedSearchGetters('getFacetByName')('category')
    )

    const showSellers = computed(() => classifiedSearchGetters('showSellers'))

    const totalRows = computed(() => classifiedSearchGetters('getTotalRows'))

    const mySearchLinks = computed(() => classifiedSearchState.mySearchLinks)

    const searchIsFavorite = computed(() => classifiedSearchState.isFavorite)

    const searchCanBeSaved = computed(() => classifiedSearchState.canBeSaved)

    const loadingFacets = computed(() => classifiedSearchState.loading.facets)

    const loadingResults = computed(() => classifiedSearchState.loading.results)

    const facets = computed(() => classifiedSearchState.facets)

    const scrollTop = computed(() => classifiedSearchState.scrollTop)

    const rootCategory = computed(
      () => classifiedSearchState.config.rootParams.category
    )

    const totalSellersClassifieds = computed(
      () => classifiedSearchState.sellersClassifiedsInfo?.total || 0
    )

    const displayedFacets = computed(() =>
      facets.value
        .map(facet => ({
          facet,
          component: getFacetComponent(facet)
        }))
        .filter(item => item.component !== null)
    )

    const isPayingUser = computed(() => userGetters('isPayingUser'))
    const isOfTypeDealer = computed(() => userGetters('isOfTypeDealer'))
    const isGuest = computed(() => userGetters('isGuest'))

    const searchId = computed(() => classifiedSearchState.searchId)

    const pageIsExplicitAndRequiresConsent = computed(() =>
      pageGetters('pageIsExplicitAndRequiresConsent')
    )

    const breadcrumbs = computed(() => classifiedSearchState.page?.breadcrumbs)

    const showMobileFacets = computed(
      () => classifiedSearchState.showMobileFacets
    )

    const showMyClassifiedsButton = computed(
      () => userGetters('isManager') && !classifiedSearchState.userOwnsSearch
    )

    const resultsText = computed(() => {
      const totalResults = showSellers.value
        ? totalSellersClassifieds.value
        : formatNumber(totalRows.value)

      return capitalizeSentences(
        tc('show 1 classified | show {count} classifieds', totalResults)
      )
    })

    watch(searchId, () => {
      classifiedSearchCommit(SET_SCROLL_TOP, 0)
    })

    function closeMobileFacetsIfOpen() {
      if (showMobileFacets.value) {
        classifiedSearchDispatch('toggleMobileFacets')
      }
    }

    async function onPopState(event: PopStateEvent) {
      if (!event.state) {
        return
      }

      if (!event.state.isInSearchPage) {
        // If the state is not related to the search page, we do not handle it
        return
      }

      classifiedSearchCommit(SET_LOADING_RESULTS, true)

      const { pathname, search } = event.target.location

      const params = await legacySearchService.getParams(pathname + search)

      classifiedSearchCommit(SET_PARAMS, params)

      classifiedSearchDispatch('search', {
        pageView: true,
        updateUrl: false
      })
    }

    function onClearAllButtonClick() {
      classifiedSearchDispatch('clearAll')
    }

    const promoModals = computed(() =>
      isOfTypeDealer.value
        ? [
            'ads',
            'marketplace',
            'salesRequest',
            'perks',
            'wantedParts',
            'audits'
          ]
        : ['ads', 'audits']
    )

    async function onSaveSearchButtonClick() {
      if (searchIsFavorite.value) {
        saveSearchLoading.value = true
        await classifiedSearchDispatch('removeFromFavorites')
        saveSearchLoading.value = false
      } else {
        isSaveSearchModalShown.value = true
      }
    }

    function getFacetComponent(facet: Facet) {
      if (!facet.visible) {
        return null
      }

      if (facet.name === 'category' && showCategoryPicker.value) {
        return null
      }

      return classifiedSearchFacetsComponentsService.getFacetComponent(
        facet.type
      )
    }

    function getFacetBindings(facet: Facet) {
      return legacySearchService.getFacetComponentBindings(facet)
    }

    function onCategoryClearClick() {
      classifiedSearchDispatch('facetChanged', {
        params: [
          {
            name: 'category',
            value: rootCategory.value
          }
        ]
      })
    }

    function hideMobileFacets() {
      if (showMobileFacets.value) {
        classifiedSearchDispatch('toggleMobileFacets')
      }
    }

    return {
      ciHistory,
      ciBookmarkSolid,
      ciBookmarkRegular,
      ciTrash,
      ciMyClassifieds,
      ciTimes,
      searchFacetsDesktopAd,
      categoryFacet,
      showCategoryPicker,
      loadingFacets,
      loadingResults,
      displayedFacets,
      isSaveSearchModalShown,
      adsKeyValues,
      shouldDisplayAds,
      mySearchLinks,
      searchCanBeSaved,
      isPayingUser,
      isOfTypeDealer,
      isGuest,
      searchId,
      isMobile,
      isPc,
      showMobileFacets,
      breadcrumbs,
      pageIsExplicitAndRequiresConsent,
      saveSearchLoading,
      searchIsFavorite,
      selectedFacetsCount,
      promoModals,
      showMyClassifiedsButton,
      resultsText,
      onCategoryClearClick,
      onClearAllButtonClick,
      onSaveSearchButtonClick,
      hideMobileFacets,
      getFacetBindings,
      getFacetComponent
    }
  },
  beforeRouteEnter(to: Route, from: Route, next: any) {
    next((vm: any) => {
      if (process.server) {
        return
      }

      if (from.name?.startsWith('__classifieds_view')) {
        const promoModalLastSeen = vm.$cookies.get('promoModalLastSeen')
        const promoModalIsSeen = vm.$cookies.get('promoModalIsSeen')

        if (promoModalIsSeen === 'true') {
          return
        }

        let modalIndex = vm.promoModals.findIndex(
          modal => promoModalLastSeen === modal
        )
        if (modalIndex === -1) {
          modalIndex = 0
        }

        const nextModalIndex =
          vm.promoModals.length - 1 < modalIndex + 1 ? 0 : modalIndex + 1
        const nextModal = vm.promoModals[nextModalIndex]

        vm.$cookies.set('promoModalLastSeen', nextModal)
        vm.$cookies.set('promoModalIsSeen', 'false', {
          maxAge: ONE_DAY * 10
        })
        vm.isPromoModalsWrapperVisible = true
      } else if (to.name === '__classifieds_search_my_classifieds') {
        const auditsPromoModalCookie = vm.$cookies.get('promoModalShown')
        if (auditsPromoModalCookie) {
          return
        }

        vm.isCreditsPromoModalVisible = true
        vm.$cookies.set('promoModalShown', 'true', {
          maxAge: ONE_DAY * 10
        })
      }
    })
  },
  head() {
    const dealerSiteService = this.$dep(DealerSiteService)

    const page = this.$store.state.classifieds.search.page

    const currentRouteFullPath = this.$store.getters[
      `${CLASSIFIED_SEARCH_NS}/getCurrentRouteFullPath`
    ]
    const consent = this.$store.state.page.consent

    const meta: MetaItem[] = page.metadata.map((metaItem: BackendMetaItem) => ({
      ...metaItem,
      hid: metaItem.name || metaItem.property
    }))

    if (!dealerSiteService.routeIsOfDealerSite(this.$router.currentRoute)) {
      meta.push({
        name: 'og:url',
        content: `https://www.car.gr${currentRouteFullPath}`
      })
    }

    if (consent?.name === 'over18') {
      meta.push(
        { name: 'rating', content: 'adult' },
        { name: 'rating', content: 'RTA-5042-1996-1400-1577-RTA' }
      )
    }

    return {
      title: page.title,
      meta
    }
  },
  i18n: defineComponentTranslations({
    saved_search: {
      en: 'Saved',
      el: 'Αποθηκευμένη'
    }
  })
})
